import {Component, Input, OnInit} from '@angular/core';
import {Contest} from '../../../model/contest/Contest';
import {TeacherExamStats} from '../../../model/stats/Stats';
import {animate, state, style, transition, trigger} from '@angular/animations';

@Component({
  selector: 'teacher-info-table',
  templateUrl: './teacher-info-table.component.html',
  styleUrls: ['./teacher-info-table.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({height: '0px', minHeight: '0'})),
      state('expanded', style({height: '*'})),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class TeacherInfoTableComponent implements OnInit {

  @Input() mobileView = false;
  @Input() regions: Map<string, string> = new Map<string, string>();
  @Input() teacherStats: TeacherExamStats[] | null = null;

  @Input() competitionId?: string;
  @Input() contest?: Contest;

  @Input() inProgress = false;

  @Input() expandContent = true;
  @Input() showPoints = true;
  @Input() showRegion = true;
  @Input() showEnrolled = false;

  expandedElement: TeacherExamStats | null = null;

  columnsToDisplay!: string[];

  constructor() {

  }

  ngOnInit(): void {
    this.columnsToDisplay = this.mobileView
      ? ['name', 'email']
      : ['name', 'email', 'phone'];

    if (this.showRegion) {
      const regionColumns = this.mobileView
        ? ['school']
        : ['region', 'school'];

      this.columnsToDisplay.push(...regionColumns);
    }

    if (this.showPoints) {
      const pointsColumns = this.mobileView
        ? ['points']
        : ['enrolled', 'students', 'points'];

      this.columnsToDisplay.push(...pointsColumns);
    }

    if (this.showEnrolled && !this.mobileView) {
      this.columnsToDisplay.push('enrolled-at');
    }
  }

}
